import { useState } from "react";
import { Col } from "antd";
import { Fade } from "react-awesome-reveal";
import { withTranslation } from "react-i18next";
import { ContentBlockProps } from "./types";
import { ServiceSection, StyledRow, ContentHead, ContentText, ContentTextSmall, VerticalButtonList, CountyButton } from "./styles";
import CaliforniaMap from "./CaliforniaMap";

const counties = [
    "Los Angeles",
    "Orange",
    "San Bernardino",
    "Riverside",
    "Fresno",
    "Santa Clara",
];

const ServiceBlock = ({ id, direction, text1, text2, text3, text4 }: ContentBlockProps) => {
    const [hoveredCounty, setHoveredCounty] = useState<string | null>(null);

    const getFillColor = (countyName: string) => {
        return hoveredCounty === countyName ? "#2A3273" : "#2159A6";
    };


    return (
        <ServiceSection id = { id }>
            <Fade direction={direction} triggerOnce>
                <>
                    <ContentHead>{text1}</ContentHead>
                    <ContentText>{text2}</ContentText>
                    <ContentTextSmall>{text3}</ContentTextSmall>

                    <StyledRow direction={direction}>
                        <Col lg={11} md={11} sm={24} xs={24}>
                            <VerticalButtonList>
                                {counties.map((county) => (
                                    <CountyButton
                                        key={county}
                                        onMouseEnter={() => setHoveredCounty(county)}
                                        onMouseLeave={() => setHoveredCounty(null)}
                                        selected={hoveredCounty === county}
                                    >
                                        {county}
                                    </CountyButton>
                                ))}
                            </VerticalButtonList>
                            <ContentTextSmall>{text4}</ContentTextSmall>
                        </Col>
                        <Col lg={13} md={13} sm={24} xs={24} style={{ textAlign: "right" }}>
                            <CaliforniaMap selectedCounty={hoveredCounty} getFillColor={getFillColor} />
                        </Col>
                    </StyledRow>
                </>
            </Fade>
        </ServiceSection>
    );
};

export default withTranslation()(ServiceBlock);
